// extracted by mini-css-extract-plugin
export default {"div":"SalesCatalogue_div__a02q5","card":"SalesCatalogue_card__0wDvJ","cards":"SalesCatalogue_cards__NEAAB"};